<template>
  <div class="fields__field fields__field--checkbox" :class="{ '-error': error }">
    <div class="field__label" v-if="label">
      <span class="control-label bold">{{ label }}</span>
    </div>
    <div class="field__checkbox">
      <label :for="identifier" class="checkbox__label" :class="{ '-checked': isChecked }">
        <input type="checkbox" class="form-check-input" :name="identifier" :value="value" :id="identifier"  @click="toggle">
        <slot></slot>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['label', 'identifier', 'value', 'error'],
  data () {
    return {
      isChecked: 0
    }
  },
  methods: {
    toggle: function () {
      if (this.isChecked === 0 || this.isChecked === false) {
        this.isChecked = 1
      } else {
        this.isChecked = 0
      }
      this.$emit('updateValue', this.isChecked)
    }
  },
  created () {
    this.isChecked = this.value
  }
}
</script>
